export default __webpack_public_path__ + "static/media/turismo.150d378d.jpg";